import React, {useEffect, useState} from 'react'
import { scrollTo } from '../../libs/util'
import styled from 'styled-components'

export default function AddItemInfo({mode, count}) {
    if(mode){}
    const [displayInfo, setDisplayInfo] = useState({ display: '' });
    const [displayType, setDisplayType] = useState('');
    const [prevCount, setPrevCount] = useState(1);


    useEffect(() => {
        const NumberCount = Number(count);
        if(prevCount === NumberCount && NumberCount === 1){
            setDisplayInfo({
                ...displayInfo,
                display: ''
            });
            setDisplayType('add');
        } else if(prevCount !== NumberCount){
            setDisplayInfo({
                ...displayInfo,
                display: ''
            });
            setDisplayType('count');
        }
        setPrevCount(NumberCount);
    }, [count]);


    const onMoveEstimate = () => {
        scrollTo('#layout_list_group')
    }

    const onClose = () => {
        setDisplayInfo({
            ...displayInfo,
            display: 'none'
        })
    }


    return(
        <tr style={displayInfo}>
            <td colSpan="7">
                <div className="box-tr">
                    <div className="box-tr_top" >
                        <EmptySpace/>
                        {/*{text}*/}
                        {displayType === 'add'
                            ? <strong>
                                견적 상품이 <span>추가</span>되었습니다.
                            </strong>
                            : <strong>
                                견적 상품의 <span>개수가 변경</span>되었습니다.
                            </strong>
                        }
                        <>
                            <a
                                className="btn-continue-shopping"
                                onClick={onMoveEstimate}>
                                견적 계속 담기 <i className="icon-angle-right" />
                            </a>
                        </>
                        {/*{this.props.mode !== 'service' || (*/}
                        {/*    <>*/}
                        {/*        <a className="btn-continue-shopping"*/}
                        {/*            onClick={() => this.onMoveEstimate()}>*/}
                        {/*            견적 계속 담기 <i className="icon-angle-right" />*/}
                        {/*        </a>*/}
                        {/*    </>*/}
                        {/*)}*/}
                    </div>

                    <button type="button" className="btn_box-tr_clse" onClick={onClose}>
                        <img
                            src={`${process.env.REACT_APP_CDN_IMG}/img_static/img_pres/_v3/btn_compare_del.gif`}
                            alt="삭제"
                        />
                    </button>
                </div>
            </td>
        </tr>
    )
}


const EmptySpace = styled.div`
    width: 64px;
    display: inline-block;
`



// WEBPACK FOOTER //
// ./src/estimate_list/components/estimate/addItemInfo.js